export { default } from './TasksListAsOwner';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListAsOwner/index.js